import { BaseCommand } from "./baseCommand";

export abstract class AbstractAccountDataCommand extends BaseCommand {
}